import React from 'react';
import { Table, TableBody, TableCell, TableRow, LinearProgress, Typography, Box, TableHead, IconButton, useMediaQuery, useTheme } from '@material-ui/core';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import moment from 'moment';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: '#FFD18E',
  },
}))(LinearProgress);

const useStyles = makeStyles((theme) => ({
  iconCircle: {
    color: '#729762',
    fontSize: 'inherit'
  },
  iconWarning: {
    color: '#E7D37F',
    fontSize: 'inherit'
  },
  tableRowGreen: {
    '&:hover': {
      backgroundColor: '#E0F2E9',
    },
  },
  tableRowYellow: {
    '&:hover': {
      backgroundColor: '#FFF9C4',
    },
  },
  listItem: {
    borderBottom: '1px solid #ddd',
    padding: theme.spacing(2),
  },
  listItemContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}));

const ProductWarrantyInfo = ({ data,invoiceDate }) => {
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  if (isSmallScreen) {
    return (
      <Box>
        {invoiceDate ? (
          data.map((row, index) => (
            <Box key={index} className={classes.listItem}>
              <Box className={classes.listItemContent}>
                <IconButton className={row.Useable ? classes.iconCircle : classes.iconWarning}>
                  {row.Useable ? <CheckCircleOutlineIcon /> : <ErrorOutlineIcon />}
                </IconButton>
              </Box>
              <Box className={classes.listItemContent}>
                <Typography variant="body1">{t('lblWarrantyDescription')}:</Typography>
                <Typography variant="body1">{row.WarrantyDescription}</Typography>
              </Box>
              <Box className={classes.listItemContent}>
                <Typography variant="body1">{t('lblStartDate')}:</Typography>
                <Typography variant="body1">{moment(row.StartDate).format('DD.MM.YYYY')}</Typography>
              </Box>
              <Box className={classes.listItemContent}>
                <Typography variant="body1">{t('lblEndDate')}:</Typography>
                <Typography variant="body1">{moment(row.EndDate).format('DD.MM.YYYY')}</Typography>
              </Box>
              <Box className={classes.listItemContent}>
                <Typography variant="body1">{t('lblWarrantyPeriod')}:</Typography>
                <Box width="100%" mr={1}>
                  <BorderLinearProgress variant="determinate" value={100} />
                </Box>
                <Typography variant="body2" color="textSecondary">{`${row.TimeDay} day`}</Typography>
              </Box>
              <Box className={classes.listItemContent}>
                <Typography variant="body1">{t('lblRemainingDays')}:</Typography>
                <Box width="100%" mr={1}>
                  <BorderLinearProgress
                    variant="determinate"
                    value={row.RemainingDays > row.TimeDay ? 100 : (row.RemainingDays / row.TimeDay) * 100}
                  />
                </Box>
                <Typography variant="body2" color="textSecondary">{`${row.RemainingDays} day`}</Typography>
              </Box>
            </Box>
          ))
        ) : (
        <Box className={classes.noWarrantyInfo}>
          <Typography variant="body2" color="textSecondary">No warranty information</Typography>
        </Box>
        )}
      </Box>
    );
  }

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell></TableCell>
          <TableCell>{t('lblWarrantyDescription')}</TableCell>
          <TableCell>{t('lblStartDate')}</TableCell>
          <TableCell>{t('lblEndDate')}</TableCell>
          <TableCell>{t('lblWarrantyPeriod')}</TableCell>
          <TableCell>{t('lblRemainingDays')}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
      {invoiceDate ? (
        data.map((row) => (
          <TableRow className={row.Useable ? classes.tableRowGreen : classes.tableRowYellow} key={row.id}>
            <TableCell>
              <IconButton className={row.Useable ? classes.iconCircle : classes.iconWarning}>
                {row.Useable ? <CheckCircleOutlineIcon /> : <ErrorOutlineIcon />}
              </IconButton>
            </TableCell>
            <TableCell>{row.WarrantyDescription}</TableCell>
            <TableCell>{moment(row.StartDate).format('DD.MM.YYYY')}</TableCell>
            <TableCell>{moment(row.EndDate).format('DD.MM.YYYY')}</TableCell>
            <TableCell>
              <Box display="flex" alignItems="center">
                <Box width="100%" mr={1}>
                  <BorderLinearProgress variant="determinate" value={100} />
                </Box>
                <Box width="200px">
                  <Typography variant="body2" color="textSecondary">{`${row.TimeDay} day`}</Typography>
                </Box>
              </Box>
            </TableCell>
            <TableCell>
              <Box display="flex" alignItems="center">
                <Box width="100%" mr={1}>
                  <BorderLinearProgress
                    variant="determinate"
                    value={row.RemainingDays > row.TimeDay ? 100 : (row.RemainingDays / row.TimeDay) * 100}
                  />
                </Box>
                <Box width="200px">
                  <Typography variant="body2" color="textSecondary">{`${row.RemainingDays} day`}</Typography>
                </Box>
              </Box>
            </TableCell>
          </TableRow>
        ))
      ) : (
        <TableRow>
          <TableCell colSpan={6} align="center">
            <Typography variant="body2" color="textSecondary">{t('lblNoWarranty')}</Typography>
          </TableCell>
        </TableRow>
      )}
    </TableBody>
    </Table>
  );
};

export default ProductWarrantyInfo;
